import { Component, OnInit } from '@angular/core';
import { Item } from '../../../core/components/listbox/listbox.component';
import { DataTaskService } from '../../../core/services/data-task.service';

@Component({
  selector: 'tt-lists',
  templateUrl: './lists.component.html',
  styleUrls: ['./lists.component.css']
})
export class ListsComponent implements OnInit {
    public itemsLists: Item[] = [];

    constructor(private datatask: DataTaskService) {

    }

    private async loadLists() {
        this.itemsLists = await this.datatask.Post(2715);
    }

    private async init() {
        this.loadLists();
    }

    ngOnInit() {
        this.init();
    }
}
